import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminSolar_connections_idLatest = z.any()
export type TagsGetAdminSolar_connections_idLatest = z.infer<typeof tagsGetAdminSolar_connections_idLatest>

export const paramsGetAdminSolar_connections_idLatest = z.object({ "id": z.string().uuid() })
export type ParamsGetAdminSolar_connections_idLatest = z.infer<typeof paramsGetAdminSolar_connections_idLatest>

export const responseGetAdminSolar_connections_idLatest = z.object({ "payload": z.union([z.null(), z.object({ "sourceAt": z.string().datetime({ offset: true }), "receivedAt": z.string().datetime({ offset: true }), "schemaVersion": z.number(), "metrics": z.record(z.union([z.number(), z.null()])).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.union([z.number(), z.null()]).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}), "metadata": z.object({ "deviceId": z.string(), "inverterSerial": z.string(), "inverterType": z.union([z.string(), z.null()]), "inverterStatus": z.union([z.string(), z.null()]), "batteryStatus": z.union([z.string(), z.null()]) }) })]).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminSolar_connections_idLatest = z.infer<typeof responseGetAdminSolar_connections_idLatest>

interface IGetAdminSolar_connections_idLatest extends BaseMethodType {
  tags: TagsGetAdminSolar_connections_idLatest,
  params: ParamsGetAdminSolar_connections_idLatest,
  response: ResponseGetAdminSolar_connections_idLatest
}
export const URL = '/admin/solar-connections/:id/latest'
export const validation = {
  get: {
    tags: tagsGetAdminSolar_connections_idLatest,
    params: paramsGetAdminSolar_connections_idLatest,
    response: responseGetAdminSolar_connections_idLatest
  }
}
export interface AdminSolar_connections_idLatest extends BaseRouteType {
  get: IGetAdminSolar_connections_idLatest
}